import { Title } from "@angular/platform-browser";
import { NG_SCROLLBAR_OPTIONS } from 'ngx-scrollbar';
import { ErrorHandler, Provider } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { CommonService } from "./core/services/common.service";
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { COMMON_SERVICE } from "./core/services/common.interface";
import { ErrorInterceptor } from "./core/helpers/error.interceptor";
import { NotificationService } from './service/notification.service';
import { GlobalErrorHandler } from "./core/services/chunk-error-handler";
import { SettingInterceptor } from "./core/helpers/setting.interceptor";
// import { SignalRNotificationService } from "./core/services/signalr.service";
import { InterstoreService } from "./pages/interstore/services/interstore.service";
import { INTERSTORE_SERVICE } from "./pages/interstore/services/interstore.interface";
import { HTTP_SERVICE, HttpService, USER_AUTHENTICATION_SERVICE, UserAuthService } from "./core/services";
import { CUSTOMER_OTP_VERIFICATION_SERVICE } from "./pages/customer-otp-verification/services/customer-otp-verification.interface";
import { CustomerOTPVerificationService } from "./pages/customer-otp-verification/services/customer-otp-verification.service";
import { SEND_NOTIFICATION_SERVICE } from "./pages/master/send-notification/services/send-notification.interface";
import { SendNotificationService } from "./pages/master/send-notification/services/send-notification.service";
import { KMR_HTTP_SERVICE, KmrHttpService } from "./core/services/kmr-http.service";

export const ProviderList: Provider[] = [
    Title,
    NotificationService,
    {
        provide: ErrorHandler,
        useClass: GlobalErrorHandler
    },
    {
        provide: NG_SCROLLBAR_OPTIONS,
        useValue: {
            visibility: 'hover'
        },
    },
    {
        provide: HTTP_SERVICE,
        useClass: HttpService
    },
    {
        provide: USER_AUTHENTICATION_SERVICE,
        useClass: UserAuthService
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: JwtInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: SettingInterceptor,
        multi: true
    },
    {
        provide: CUSTOMER_OTP_VERIFICATION_SERVICE,
        useClass: CustomerOTPVerificationService
    },
    {
        provide: INTERSTORE_SERVICE,
        useClass: InterstoreService
    },
    {
        provide: COMMON_SERVICE,
        useClass: CommonService
    },
    {
        provide: SEND_NOTIFICATION_SERVICE,
        useClass: SendNotificationService
    },
    {
        provide: KMR_HTTP_SERVICE,
        useClass: KmrHttpService
    }
    // {
    //     provide: SignalRNotificationService,
    //     useClass: SignalRNotificationService
    // }
];
